import { useCallback } from "react";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";
import {
  type IDraftEntry,
  type ISelectedDraft,
} from "src/pages/Settings/Miscellaneous/DraftEntries/DraftEntries";

import DraftEntryRow from "./DraftEntryRow";

const headers = [
  { label: "Logbook Name" },
  { label: "Date Created" },
  { label: "Created By" },
  { label: "Selected" },
];

interface Props {
  data: IDraftEntry[];
  loading: boolean;
  selected: ISelectedDraft[];
  handleSelect: (row: IDraftEntry) => void;
  deleted: boolean;
}

const DraftEntriesTable = ({
  data,
  loading,
  selected,
  handleSelect,
  deleted,
}: Props) => {
  const renderRow = useCallback(
    ({ row }: { row: IDraftEntry }) => {
      const onClick = () => handleSelect(row);
      let checked = false;
      if (deleted) {
        checked = !!selected.find(e => e.id === row.id);
      } else {
        checked = !!selected.find(e =>
          row.meid
            ? e.meid === row.meid
            : row.partid
              ? e.partid === row.partid
              : e.lbeid === row.lbeid,
        );
      }
      return <DraftEntryRow row={row} checked={checked} onClick={onClick} />;
    },
    [deleted, handleSelect, selected],
  );

  return (
    <ScrollableTable
      headers={headers}
      loading={loading}
      data={data}
      renderRow={renderRow}
      keyExtractor={row => row.id ?? row.meid ?? row.partid ?? row.lbeid}
    />
  );
};

export default DraftEntriesTable;
